import AllTickets from "./views/HelpDesk/AllTickets";
import RaiseTicket from "./views/HelpDesk/RaiseTicket";
import TicketHistory from "./views/HelpDesk/TicketHistory";
import ScrutinyCandidates from "./views/Scrutiny/ScrutinyCandidates";
import Advertisments from "./views/StudentRegisteration/Advertisments";
import ApplicationForm from "./views/StudentRegisteration/ApplicationForm";
import CandidatePreference from "./views/StudentRegisteration/Preferences/CandidatePreference";
import Profile from "./views/StudentRegisteration/Profile";
import ProfileMilestones from "./views/StudentRegisteration/ProfileMilestones";
import Scorecard from "./views/StudentRegisteration/Scorecard";
import StudentRegisteration from "./views/StudentRegisteration/StudentRegisteration";
import ViewProfile from "./views/StudentRegisteration/ViewProfile";
import ViewApplication from "./views/Scrutiny/ViewApplication";
import PaymentPage from "./views/Payment/PaymentPage";
import PaymentStatus from "./views/Payment/PaymentStatus";
import ViewTicketHistory from "./views/Admin/viewTicketHistory";
import HelpDesk from "./views/Admin/HelpDesk";
import CandidateReport from "./views/Reports/CandidateReport";
import Labels from "./views/Admin/Labels";
import TicketReply from "./views/HelpDesk/TicketReply";
import LabelListing from "./views/Admin/labelListing";
import PreviewPage from "./views/StudentRegisteration/PreviewPage";
import DashBoard from "./views/StudentRegisteration/DashBoard";
import AdmitCard from "./views/Admin/AdmitCard";
import DownloadAdmitCard from "./views/StudentRegisteration/admitcard/DownloadAdmitCard";
import AgencyAdmitCard from "./views/StudentRegisteration/admitcard/AgencyAdmitCard";
import Objection from "./views/objection/Objection";
import RaisedObjections from "./views/objection/RaisedObjections";
// import ReportPreviewPage from "./views/Reports/ReportPreviewPage";

const routes = [
  // {
  //   path: "/report",
  //   name: "Report",
  //   element: ReportPreviewPage,
  //   roles: ["SUPERADMIN"],
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    element: DashBoard,
    roles: ["SUPERADMIN"],
  },
  {
    path: "/label-Listing",
    name: "Ticket Label",
    element: LabelListing,
  },
  {
    path: "/preview-page",
    name: "Preview Page",
    element: PreviewPage,
    roles: ["SUPERADMIN", "ADMIN"],
  },
  {
    path: "/ticket-reply",
    name: "Ticket Reply Template",
    element: TicketReply,
    roles: ["SUPERADMIN"],
  },
  {
    path: "/manage-labels",
    name: "Mange Labels",
    element: Labels,
    roles: ["SUPERADMIN"],
  },
  {
    path: "/payment",
    name: "Payment Page",
    element: PaymentPage,
    roles: ["SUPERADMIN", "CANDIDATE"],
  },
  {
    path: "/candidate-report",
    name: "Candidate Reports",
    element: CandidateReport,
    roles: ["SUPERADMIN", "ADMIN"],
  },
  {
    path: "/view-ticket-history",
    name: "View Ticket History",
    element: ViewTicketHistory,
    roles: ["SUPERADMIN", "CANDIDATE"],
  },
  {
    path: "/adminHelpDesk",
    name: "Admin helpDesk",
    element: HelpDesk,
    roles: ["SUPERADMIN"],
  },
  {
    path: "/payment-status",
    name: "Payment Status",
    element: PaymentStatus,
    roles: ["SUPERADMIN", "CANDIDATE"],
  },
  {
    path: "/raise-ticket",
    name: "Raise Ticket",
    element: RaiseTicket,
    roles: ["SUPERADMIN", "CANDIDATE"],
  },
  // {
  //   path: "/all-tickets",
  //   name: "All Tickets",
  //   element: AllTickets,
  //   roles: ["CANDIDATE"],
  // },
  // {
  //   path: "/ticket-history",
  //   name: "Ticket History",
  //   element: TicketHistory,
  //   roles: ["SUPERADMIN", "CANDIDATE"],
  // },

  // {
  //   path: "/declaration",
  //   name: "Declaration Page",
  //   element: ViewProfile,
  //   roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  // },
  {
    path: "/scrutiny",
    name: "Scrutiny Candidates",
    element: ScrutinyCandidates,
    roles: ["SCRUTINY", "ADMIN", "SUPERADMIN"],
  },
  {
    path: "/view-application",
    name: "View Application",
    element: ViewApplication,
    roles: ["admin", "SUPERADMIN", "SCRUTINY"],
  },
  {
    path: "/preferences",
    name: "Preference Page",
    element: CandidatePreference,
    roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  },
  // {
  //   path: "/application-form",
  //   name: "Application Form",
  //   element: ApplicationForm,
  //   roles: ["CANDIDATE"],
  // },
  // {
  //   path: "/profile",
  //   name: "Profile",
  //   element: Profile,
  //   roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  // },
  // {
  //   path: "/profile-milestones",
  //   name: "Profile",
  //   element: ProfileMilestones,
  //   roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  // },
  // {
  //   path: "/advertisement",
  //   name: "Advertisemnts",
  //   element: Advertisments,
  //   roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  // },
  // {
  //   path: "/milestone-listing",
  //   name: "Registeration",
  //   element: StudentRegisteration,
  //   roles: ["CANDIDATE"],
  // },
  // {
  //   path: "/scorecard",
  //   name: "Scorecard",
  //   element: Scorecard,
  //   roles: ["CANDIDATE"],
  // },
  {
    path: "/view-application",
    name: "View Application",
    element: ViewApplication,
    roles: ["ADMIN", "SUPERADMIN", "SCRUTINY"],
  },
  // {
  //   path: "/",
  //   name: "Registeration",
  //   element: StudentRegisteration,
  //   roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  // },
  {
    path: "/ac",
    name: "Admit Card",
    element: AdmitCard,
    roles: ["admin", "SUPERADMIN"],
  },
  {
    path: "/dac",
    name: "Download Admit Card",
    element: DownloadAdmitCard,
    roles: ["CANDIDATE"],
  },
  {
    path: "/cac",
    name: "Download Candidate Admit Card",
    element: AgencyAdmitCard,
    roles: ["AGENCY"],
  },
  // {
  //   path: "/objection",
  //   name: "Objection",
  //   element: Objection,
  //   roles: ["admin", "SUPERADMIN", "CANDIDATE"],
  // },
  // {
  //   path: "/raised-objections",
  //   name: "Raised Objection",
  //   element: RaisedObjections,
  //   roles: ["admin", "SUPERADMIN", "AGENCY"],
  // },
];

export default routes;
